import Datetime from 'utils/datetime/datetime'

export const SETTLEMENT_OPTIMIZATION_MAX_PERIOD_MONTHS = 1

/**
 * The hours a settlement optimization runs for. The backend accepts whole hours only, and its end
 * is the start of the last hour, inclusive: the picker's 23:59 floors to 23:00, keeping that hour.
 */
export function toSettlementOptimizationWindow(period: Period): { startTime: ISODateTime; endTime: ISODateTime } {
  return {
    startTime: Datetime.ISODatetimeTo00Minutes(Datetime.toISOString(period.startTime)),
    endTime: Datetime.ISODatetimeTo00Minutes(Datetime.toISOString(period.endTime)),
  }
}

export function periodExceedsSettlementOptimizationLimit(period: Period): boolean {
  const startTime = Datetime.toISOString(period.startTime)
  const endTime = Datetime.toISOString(period.endTime)

  return Datetime.isAfter(endTime, Datetime.addMonths(startTime, SETTLEMENT_OPTIMIZATION_MAX_PERIOD_MONTHS))
}
